import { validatePageData } from './validators';

export const exportPageConfig = (pageData) => {
  const dataStr = JSON.stringify(pageData, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  const url = URL.createObjectURL(dataBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `page-config-${Date.now()}.json`;
  link.click();
  URL.revokeObjectURL(url);
};

export const importPageConfig = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        const validation = validatePageData(data);
        if (validation.isValid) {
          resolve(data);
        } else {
          reject(new Error(validation.errors.join(', ')));
        }
      } catch (error) {
        reject(new Error('Invalid JSON file'));
      }
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
};
